import { headerStyles } from "@insite/content-library/Widgets/InvoiceDetails/InvoiceDetailHeader";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

headerStyles.printButton = {
    variant: "tertiary",
    css: css`
        background: rgb(105, 163, 66);
        border: 2px solid rgb(105, 163, 66);
        padding: 0px 21px;
    `,
};
headerStyles.shareEntityButtonStyles = {
    button: {
        css: css`
            margin-left: 10px;
            border: 1px solid #cccccc;
        `,
        // buttonType: "outline",
        variant: "secondary",
    },
};
